import { createFileRoute, redirect } from "@tanstack/react-router";

/** Drivers is the first screen of Manage Warehouse, so the bare URL lands there. */
export const Route = createFileRoute(
  "/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant/",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$lang/orgs/$org/deliver/manage/$tenant/drivers",
      params,
      replace: true,
    });
  },
});
